import { useEffect, useRef, useState } from "react";

import { SessionContextProps } from "../../../../Context/SessionContext";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import IntroField, { IIntroFieldProps } from "../Components/IntroField";

type IContextProps = Pick<SessionContextProps, "customer" | "setCustomer">;

type IProvisionedProps = IContextProps & Omit<IIntroFieldProps, "value" | "onChange" | "onChangeValue">;

/** The Distance To Center field and associated Side Effects
 * Controlled by the Session context, and uses the User context for the list of Centers.
 */
const ProvisionedDistanceField: React.FC<IProvisionedProps> = ({ customer, setCustomer, ...rest }) => {
  const [value, setValue] = useState(customer.distanceToCenter?.toString() || "");
  const centerRef = useRef(customer.center);
  useEffect(() => {
    centerRef.current = customer.center;
  }, [customer.center]);

  const onDistanceAccepted = (value?: string) => {
    if (!value) return setCustomer(c => ({ ...c, distanceToCenter: null }));
    const distanceToCenter = Number(value);
    setCustomer(c => ({ ...c, distanceToCenter }));
  };

  return IntroField({
    value: value,
    onChange: (distance: string | undefined) => onDistanceAccepted(distance),
    onChangeValue: (distance: string | undefined) => setValue(distance || ""),
    ...rest
  });
};

/** Provides Session properties to the Distance Field. */
const SessionContextDistanceField = SessionContextValueProvider({
  Component: ProvisionedDistanceField,
  map: ({ customer, setCustomer }) => {
    return {
      customer,
      setCustomer
    };
  }
});

export default SessionContextDistanceField;
